import React from 'react';

function AnythingDetailsText({ anything, ...rest }) {
  const { value1: text } = anything;

  return <div {...rest}>{text}</div>;
}

export default AnythingDetailsText;
